module.exports = __webpack_public_path__ + "img/服务案例_BMS_白2.837f41fe.svg";